// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"sub-title-module--sub-title--32Hg1"};